import { render, staticRenderFns } from "./AttributeView.vue?vue&type=template&id=76247a4a&"
import script from "./AttributeView.vue?vue&type=script&lang=js&"
export * from "./AttributeView.vue?vue&type=script&lang=js&"
import style0 from "./AttributeView.vue?vue&type=style&index=0&id=76247a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports